import data from '@emoji-mart/data'
import Picker from '@emoji-mart/react'
import { initHoverActions } from 'shared/position/hover-actions'
import { StackIcon } from 'shared/ui'

import type { Message, ReactionBody } from '../../model/types'

import { getPreviewEmojis } from '../../../../config/emojiSetup.ts'
import { api } from '../../api'
import { Label } from '../../const'
import { useCurrentId } from '../../hooks'
import css from './style.module.scss'

const { $id, popoverListeners, triggerListeners, useSyncPopoverState } =
	initHoverActions({ anchorCN: css.selectTrigger })

function isNotReadyYet(
	emoji: string,
	options: {
		isLoading: boolean
		originalArgs?: ReactionBody
	},
	message: string
) {
	const isSameMessage = options.originalArgs?.message === message
	const isSameEmoji = options.originalArgs?.emoji === emoji

	return options.isLoading && isSameMessage && isSameEmoji
}

const previews = getPreviewEmojis();

function EmojiActionsPopover() {
	const [react, options] = api.useReactionMutation()
	const conversation = useCurrentId()

	const ref = useSyncPopoverState()

	return (
		<div className={css.selectMenu} ref={ref} {...popoverListeners}>
			<Picker
				data={data}
				onEmojiSelect={({ native: emoji }: { native: string }) => {
					console.log(emoji)
					const message = $id.get()
					const isLoading = isNotReadyYet(emoji, options, message ?? '')

					if (!isLoading) {
						react({
							conversation,
							emoji,
							mark: true,
							message
						})
						$id.set('')
					}
				}}
				onMouseEnter={popoverListeners.onMouseEnter}
			/>
		</div>
	)
}

function EmojiSelect({ message_id: message }: Message) {
	const [react, options] = api.useReactionMutation()
	const conversation = useCurrentId()

	return (
		<>
			{previews.map(emoji => (
				<button
					className={`li-⚪ ${css.action}`}
					disabled={isNotReadyYet(emoji, options, message)}
					key={emoji}
					onClick={() => {
						react({
							conversation,
							emoji,
							mark: true,
							message
						})
					}}
					type='button'
				>
					<span className={css.quick}>{emoji}</span>
				</button>
			))}

			<button
				aria-label={Label.Emoji}
				className='li-⚪'
				{...triggerListeners}
				title={Label.Emoji}
				type='button'
				value={message}
			>
				<StackIcon icon='emoji' stack='linkedin' width={18} />
			</button>
		</>
	)
}

export { EmojiActionsPopover, EmojiSelect }
